/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faint_Wide_Falcon_MendInputs */

const en_faint_wide_falcon_mend = /** @type {(inputs: Faint_Wide_Falcon_MendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import of access rights`)
};

const de_faint_wide_falcon_mend = /** @type {(inputs: Faint_Wide_Falcon_MendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import von Zugriffsrechten`)
};

/**
* | output |
* | --- |
* | "Import of access rights" |
*
* @param {Faint_Wide_Falcon_MendInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const faint_wide_falcon_mend = /** @type {((inputs?: Faint_Wide_Falcon_MendInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faint_Wide_Falcon_MendInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faint_wide_falcon_mend(inputs)
	return de_faint_wide_falcon_mend(inputs)
});